export default __webpack_public_path__ + "static/media/home-logo.4ecd46a7.png";